import tagsService from '@/services/tagsService';

export default {
	namespaced: true,
	state: {
		tags: []
	},

	mutations: {
		setTags(state, payload) {
			state.tags = payload;
		}
	},

	actions: {
		async getTags({ commit }) {
			try {
				const data = await tagsService.getAllTags();
				commit('setTags', data);
				return data;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async getTagById({ commit }, payload) {
			try {
				return await tagsService.getTagById(payload);
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async putTag({ commit }, payload) {
			try {
				return await tagsService.putTag(payload);
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async postTag({ commit }, payload) {
			try {
				return await tagsService.postTag(payload);
			} catch (error) {
				console.log(error);
			}
		}
	},

	getters: {}
};
